import {
  FMSInterface,
  FMSServiceInterface,
  FMSServiceReturnData,
  FMSType,
  FMSValidAuth,
  GetTenantResponse,
  GetTenantResponseStatus,
  LeaseAccountStatus,
  Log,
  NormalizedFMSTenantInterface,
  SpaceInterface,
  UnitInterface,
} from "@swivl-mono/types";

// const log = CreateLogger("FMS:Helper");
export class FMSHelper {
  static sortUnits(units: UnitInterface[]): UnitInterface[] {
    return units.sort((a, b) => {
      if (a.width && b.width && a.length && b.length) {
        const aArea = a.width * a.length;
        const bArea = b.width * b.length;

        if (aArea === bArea) {
          if (a.rate && b.rate) {
            return Number(a.rate) - Number(b.rate);
          }
        }

        if (aArea < bArea) {
          return -1;
        }
        if (aArea > bArea) {
          return 1;
        }
      }
      if (a.width) {
        return -1;
      }
      if (b.width) {
        return 1;
      }
      return 0;
    });
  }
  static isFMSServiceReturnData(obj: any): obj is FMSServiceReturnData<GetTenantResponse> {
    return obj && "normalized" in obj;
  }

  static isGetTenantResponse(obj: any): obj is GetTenantResponse {
    return obj && "status" in obj;
  }

  static clearUnknownTenant(tenant: NormalizedFMSTenantInterface) {
    let name = tenant.name;
    name.replace("Unknown", "").replace("Unknown", "").trim();
    tenant.name = name;
    return tenant;
  }

  static clearUnknownTenants(tenants: NormalizedFMSTenantInterface[]): NormalizedFMSTenantInterface[] {
    return tenants.map((tenant) => FMSHelper.clearUnknownTenant(tenant));
  }

  static handleTenantResponse(response: GetTenantResponse) {
    if (response.status === GetTenantResponseStatus.SUCCESS) {
      //NOTE: REFACTOR
      // if (response.tenant?.UserAccountStatus === LeaseAccountStatus.ACTIVE) {
      //   return response.tenant;
      // }
    }
    return null;
  }

  static convertTenantsToMap<T extends { [key in K]?: any }, K extends keyof any>(arr: T[], idKey: K): { [key: string]: T } {
    return arr.reduce(
      (acc, item) => {
        if (item && item[idKey] !== undefined) {
          acc[(item[idKey] as any).toString()] = item;
        }
        return acc;
      },
      {} as { [key: string]: T },
    );
  }

  static cleanPhoneNumber(phone: string) {
    if (!phone) return "";
    return phone.replace("+1", "").replace(/\D/g, "").trim();
  }

  static createOrgFMSMap(fmsSyncEntities: FMSInterface[]): Map<number, FMSInterface[]> {
    const orgFMSMap: Map<number, FMSInterface[]> = new Map();
    for (const fmsEntity of fmsSyncEntities) {
      if (!orgFMSMap.has(fmsEntity.orgId)) {
        orgFMSMap.set(fmsEntity.orgId, []);
      }
      if (orgFMSMap && fmsEntity && fmsEntity.orgId) {
        orgFMSMap.get(fmsEntity.orgId)?.push(fmsEntity);
      }
    }
    return orgFMSMap;
  }
}
// export { sortUnits, isFMSServiceReturnData, isGetTenantResponse, clearUnknownTenant, clearUnknownTenants, handleTenantResponse, convertTenantsToMap, cleanPhoneNumber };
